(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('EnsambleSearch', EnsambleSearch);

    EnsambleSearch.$inject = ['$resource'];

    function EnsambleSearch($resource) {
        var resourceUrl =  'api/_search/ensambles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
